import React from 'react';
import {useTranslation} from '../../../hook/useTranslation';
import './Entry.scss';
import Intro from '../../intro/Intro';

export default function LayoutEntry() {
    const i18n = useTranslation();

    return (
        <div className="career-model__entry">
            <div className="career-model__entry--row row">
                <div className="career-model__entry--col col">
                    <h2 className="career-model__entry--title">{i18n.translate(`show.items.title`)}</h2>
                    <p className="career-model__entry--desc">{i18n.translate(`show.items.description`)}</p>
                </div>
                <div className="career-model__entry--col col">
                    <Intro text={i18n.translate(`show.items.links.goto_label`)}
                           uri={i18n.translate(`show.back_link`) + i18n.translate(`show.items.links.goto_link`)}
                           size="sm"/>
                </div>
            </div>
        </div>
    );
};
